// export const params = {

//     PHYSICS: {

//         // STIFFNESS: 0.35,
//         STIFFNESS: 0.4,
//        // STIFFNESS: 0.2,
//         MAX_BOUNDS: 2.0,
//         TIMESTEP: 0.0016,
//         // CLAMP: 0.03,
//         CLAMP: 0.001,
//         // CLAMP: 0.0,
//         STEPS: 1
//     },

//     CLOTH: {

//         SIZE: 128

//     },

//     NOISE: {

//         SPATIAL_FREQ: 10.9,
//         TEMPORAL_FREQ: 0.1,
//         AMP:0.01,

//     },

//     SHADOW: {
//         SIZE: 1024 * 2.0,
//         // BIAS: 0.005
//         BIAS: 0.01
//     }

// }

export const params = {

    PHYSICS: {

        // STIFFNESS: 0.38,
        //  STIFFNESS: 0.07,

        // STIFFNESS: 0.07,
        STIFFNESS: 0.33,
        MAX_BOUNDS: 2.0,
        TIMESTEP: 0.0016,
        // CLAMP: 0.03,
        // CLAMP: (1/128.0) * 0.5,
        // CLAMP: 0.045,
        // CLAMP: 0.00005,
        CLAMP: 0.0001,
        // CLAMP: 0.0,
        // STEPS: 4
        STEPS: 1
    },

    CLOTH: {

        SIZE: 128

    },

    NOISE: {

        SPATIAL_FREQ: 10.9,
        TEMPORAL_FREQ: 0.1,
        AMP:0.1,

    },

    SHADOW: {
        SIZE: 1024 * 2.0,
        // BIAS: 0.005
        BIAS: 0.01
    }

}